import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { InviteType } from '../Output/components/ShareModal/ShareModal.meta';
import { useClientId } from '../../_hooks/useClientId';
import { queryKeys } from './queryKeys';

interface Params {
  clientName: string;
  clientEmail: string;
  shareType: InviteType;
  clientId: number;
}

const shareResults = async ({
  clientName,
  clientEmail,
  shareType,
  clientId,
}: Params): Promise<null> => {
  return authFetch(
    urlWithParams(`/BeFi20/Survey/${shareType}`, {
      clientId,
    }),
    {
      method: 'POST',
      ...httpBodyOptions({ clientName, clientEmail }, true),
    },
  );
};

type MutationParams = Omit<Params, 'clientId'>;

export const useShareResultsMutation = () => {
  const clientId = useClientId();
  const queryClient = useQueryClient();

  return useMutation((params: MutationParams) => shareResults({ ...params, clientId }), {
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.overview(clientId));
    },
  });
};
